import React from 'react'
import {connect} from 'react-redux'
import Modal from 'react-modal';
import {getOpenedSubform, getWindowSizes} from "./SubformsReducers";
import {
  SUBFORM_BILLING_ADDRESS,
  SUBFORM_CUSTOMER,
  SUBFORM_PERSONA,
  SUBFORM_SHIPPING_ADDRESS
} from "./SubformsConstants";
import {closeSubform, createCustomer, createPersona, createAddress, windowResize} from './SubformsActions';
import {ORDER_CHANGE_BILLING_ADDRESS, ORDER_CHANGE_SHIPPING_ADDRESS} from "../OrderActions";
import {getOrderForm} from "../OrderReducers";
import CustomerContainer from "./customer/CustomerContainer";
import PersonaContainer from "./customer/PersonaContainer";
import AddressContainer from "./customer/AddressContainer";

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    zIndex: 2000
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0px',
    width: '650px'
  }
};

Modal.setAppElement(document.getElementById('root'));

const SubformsContainer = ({openedSubForm, windowSize, closeSubform, config, orderForm, createCustomer, createPersona, createAddress, windowResize}) => {

  customStyles.content.width = (windowSize.width * 0.8) + 'px';

  const getAddressType = () => {
    if (openedSubForm === SUBFORM_BILLING_ADDRESS) {
      return ORDER_CHANGE_BILLING_ADDRESS;
    }
    return ORDER_CHANGE_SHIPPING_ADDRESS;
  };

  const onWindowResize = () => {
    windowResize({
      width: window.document.documentElement.clientWidth,
      height: window.document.documentElement.clientHeight
    });
  };

  const onCustomerSubmit = (form) => {
    createCustomer(form, config);
  };

  const onPersonaSubmit = (form) => {
    const data = {
      ...form,
      birthday: Number(form.birthday)
    };
    createPersona(data, config, orderForm.customer);
  };

  const onAddressSubmit = (form) => {
    createAddress(form, config, getAddressType(), orderForm.customer);
  };

  const getOpenedModal = () => {
    if (openedSubForm === SUBFORM_CUSTOMER) {
      window.addEventListener('resize', onWindowResize);
      return <div>
        <Modal
          isOpen={true}
          onRequestClose={closeSubform}
          style={customStyles}
          contentLabel="Customer Form"
        >
          <CustomerContainer
            onCancel={closeSubform}
            onSubmit={onCustomerSubmit}
            windowSize={windowSize}
          />
        </Modal>
      </div>;
    }
    if (openedSubForm === SUBFORM_PERSONA) {
      window.addEventListener('resize', onWindowResize);
      return <div>
        <Modal
          isOpen={true}
          onRequestClose={closeSubform}
          style={customStyles}
          contentLabel="Persona Form"
        >
          <PersonaContainer
            onCancel={closeSubform}
            onSubmit={onPersonaSubmit}
            windowSize={windowSize}
            customerId={orderForm.customer}
          />
        </Modal>
      </div>;
    }
    if (openedSubForm === SUBFORM_BILLING_ADDRESS || openedSubForm === SUBFORM_SHIPPING_ADDRESS) {
      window.addEventListener('resize', onWindowResize);
      return <div>
        <Modal
          isOpen={true}
          onRequestClose={closeSubform}
          style={customStyles}
          contentLabel="Persona Form"
        >
          <AddressContainer
            onCancel={closeSubform}
            onSubmit={onAddressSubmit}
            windowSize={windowSize}
            customerId={orderForm.customer}
            addressType={getAddressType()}
          />
        </Modal>
      </div>;
    }
    window.removeEventListener('resize', onWindowResize);
    return '';
  };

  return (
    <div>
      {getOpenedModal()}
    </div>
  );
};

SubformsContainer.propTypes = {};

const mapStateToProps = (state) => ({
  openedSubForm: getOpenedSubform(state),
  windowSize: getWindowSizes(state),
  config: state.app.config,
  orderForm: getOrderForm(state)
});

export default connect(
  mapStateToProps,
  {closeSubform, createCustomer, createPersona, createAddress, windowResize}
)(SubformsContainer);



// WEBPACK FOOTER //
// ./src/order/subforms/SubformsContainer.js